var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.toPrint }
            },
            [_vm._v("打印")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("验收单信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showPurchReceiptFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowPurchReceipt()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showPurchReceiptFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showPurchReceiptFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPurchReceiptFlag
        ? [
            _c("div", { staticClass: "simple-form" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.purchReceipt.title || "无"))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.purchReceipt.innerNo || "无"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.cgVoucherInnerNo || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.purchReceipt.orderNo != null
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "table-cell-link",
                            on: { click: _vm.toOrderPage }
                          },
                          [_vm._v(_vm._s(_vm.purchReceipt.orderNo))]
                        )
                      ])
                    : _c("span", [_vm._v(_vm._s(_vm.purchReceipt.orderNo))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.reservedNo || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.buyerRealComCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.buyerRealComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.recvComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.costCenterCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.buyerInnerSellerCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.purchReceipt.sellerName ||
                          _vm.purchReceipt.sellerRealComName
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(11),
              _vm._v(" "),
              _vm._m(12),
              _vm._v(" "),
              !_vm.isReturn
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(13),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [_vm._v(_vm._s(_vm.purchReceipt.orderDate))])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.isReturn ? "退货" : "收货") + "日期")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.purchReceipt.recvDate))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.purchReceipt.createTime))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(15),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.ledgerTime || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.purchReceipt.pullBackNo != null &&
              _vm.purchReceipt.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _vm.purchReceipt.pulledBack
                        ? _c("span", [_vm._v("是")])
                        : _c("span", [_vm._v("否")])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.purchReceipt.pullBackNo != null &&
              _vm.purchReceipt.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(17),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.purchReceipt.rejectCause || ""))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.purchReceipt.pullBackNo != null &&
              _vm.purchReceipt.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(18),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.purchReceipt.pullBackNo || ""))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.purchReceipt.pullBackNo != null &&
              _vm.purchReceipt.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(19),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _vm.purchReceipt.pulledBackApplyState == 0
                        ? _c("span", [_vm._v("待申请")])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.auditStateMap[
                                  _vm.purchReceipt.pulledBackAuditState
                                ]
                              )
                            )
                          ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.purchReceipt.pullBackNo != null &&
              _vm.purchReceipt.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(20),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.purchReceipt.revokeReservedNo || "无")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.purchReceipt.pullBackNo != null &&
              _vm.purchReceipt.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(21),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.purchReceipt.revokeLedgerTime || ""))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(22),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.purchReceipt.invalid
                    ? _c("span", [_vm._v("是")])
                    : _c("span", [_vm._v("否")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(23),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.invalidCause || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(24),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.recvCreatorName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(25),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.auditorName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(26),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.invoiceTypeMap[_vm.purchReceipt.invoiceType])
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(27),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.taxOffset ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(28),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        parseFloat(_vm.purchReceipt.initTaxRate || 0).toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(29),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        parseFloat(_vm.purchReceipt.taxRate || 0).toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(30),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.purchReceipt.fiscalSspFlag ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              !_vm.purchReceipt.jointInvokeDone &&
              _vm.purchReceipt.jointInvokeErrMsg != null
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(31),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.purchReceipt.jointInvokeErrMsg || ""))
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReturn && !_vm.purchReceipt.alterFlag
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("订货验收信息")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "shrink-tab fr",
                  class: _vm.showGoodsOrderItemListFlag ? "current" : "",
                  on: {
                    click: function($event) {
                      _vm.doShowGoodsOrderItemList()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.showGoodsOrderItemListFlag ? "隐藏" : "展开")
                    )
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.showGoodsOrderItemListFlag
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showGoodsOrderItemListFlag
              ? _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "dataTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.goodsOrderItemList,
                          border: "",
                          maxHeight: "400",
                          "summary-method": _vm.getGoodsOrderItemSum,
                          "show-summary": ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetDefCode",
                            label: "资产定义编码",
                            fixed: "",
                            "min-width": "200"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            label: "资产定义名称",
                            fixed: "",
                            width: "250"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "assetNature",
                            label: "资产属性",
                            width: "120"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.assetNatureMap[rows.row.assetNature]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: "订购数量",
                            width: "120",
                            align: "right"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPrice",
                            label: "订购未税单价(元)",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxPrice != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.ntxPrice.toFixed(2))
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPriceZ",
                            label: "订购未税总金额(元)",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxPrice != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              rows.row.ntxPrice *
                                              rows.row.quantity
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate",
                            label: "税率(%)",
                            width: "120",
                            align: "right",
                            "render-header": _vm.renderTaxRate
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxRate != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.taxRate.toFixed(2))
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            width: "100",
                            prop: "taxRate",
                            label: "税额(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxRate != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              ((rows.row.price *
                                                rows.row.quantity || 0) /
                                                (1 + rows.row.taxRate * 0.01)) *
                                              (rows.row.taxRate * 0.01)
                                            ).toFixed(2) || 0.0
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "订购含税单价(元)",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.price != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.price.toFixed(2))
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "priceZ",
                            label: "订购含税总金额(元)",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.price != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              rows.row.price * rows.row.quantity
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "receiptQuantity",
                            label: "验收数量",
                            width: "120",
                            align: "right"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "receiptNtxAmount",
                            label: "验收未税总金额(元)",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.receiptNtxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            rows.row.receiptNtxAmount.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "receiptAmount",
                            label: "验收含税总金额(元)",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.receiptAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            rows.row.receiptAmount.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReturn
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("验收商品信息")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "shrink-tab fr",
                  class: _vm.showGoodsItemListFlag ? "current" : "",
                  on: {
                    click: function($event) {
                      _vm.doShowGoodsItemList()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.showGoodsItemListFlag ? "隐藏" : "展开"))
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.showGoodsItemListFlag
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showGoodsItemListFlag
              ? [
                  _vm.purchReceipt.goodsItemList != null &&
                  _vm.purchReceipt.goodsItemList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "table-layout" },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "dataTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.purchReceipt.goodsItemList,
                                border: "",
                                maxHeight: "400",
                                "summary-method": _vm.getGoodsItemSum,
                                "show-summary": ""
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "goodsTitle", label: "商品名称" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "catName",
                                  label: "商品分类",
                                  width: "150"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "brandName",
                                  label: "商品品牌",
                                  width: "150"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "quantity",
                                  label: "数量",
                                  width: "120",
                                  align: "right"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "unit",
                                  label: "单位",
                                  width: "120"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ntxPrice",
                                  label: "未税单价(元)",
                                  width: "120",
                                  align: "right"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.ntxPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.ntxPrice.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ntxAmount",
                                  label: "未税总金额(元)",
                                  width: "120",
                                  align: "right"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.ntxAmount != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.ntxAmount.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "taxRate",
                                  label: "税率(%)",
                                  width: "120",
                                  align: "right"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.taxRate != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.taxRate.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  width: "100",
                                  prop: "taxRate",
                                  label: "税额(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.taxRate != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  (
                                                    ((rows.row.wtxAmount || 0) /
                                                      (1 +
                                                        rows.row.taxRate *
                                                          0.01)) *
                                                    (rows.row.taxRate * 0.01)
                                                  ).toFixed(2) || 0.0
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "wtxPrice",
                                  label: "含税单价(元)",
                                  width: "120",
                                  align: "right"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.wtxPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.wtxPrice.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "wtxAmount",
                                  label: "含税总金额(元)",
                                  width: "120",
                                  align: "right"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(rows) {
                                      return [
                                        rows.row.wtxAmount != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  rows.row.wtxAmount.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("其他费用")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showReceiptFeeFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowReceiptFee()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showReceiptFeeFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showReceiptFeeFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showReceiptFeeFlag
        ? [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.purchReceipt.feeItemList,
                  border: "",
                  "tooltip-effect": "dark",
                  "summary-method": _vm.getFeeItemSum,
                  "show-summary": "",
                  maxHeight: "400"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "feeType",
                    label: "费用类型",
                    width: "150",
                    fixed: "",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.purchFeeTypeMap[rows.row.feeType])
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "name",
                    label: "名称",
                    fixed: "",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "brandName",
                    label: "品牌",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "modelSpec",
                    label: "规格",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "unit",
                    width: "60",
                    label: "单位"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "price",
                    align: "right",
                    width: "120",
                    label: "单价(元)"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.price != null
                            ? _c("span", [
                                _vm._v(_vm._s(rows.row.price.toFixed(2)))
                              ])
                            : _c("span", [_vm._v("0.00")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "quantity",
                    width: "120",
                    label: "数量"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "amount",
                    align: "right",
                    width: "120",
                    label: "小计(元)"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.amount != null
                            ? _c("span", [
                                _vm._v(_vm._s(rows.row.amount.toFixed(2)))
                              ])
                            : _c("span", [_vm._v("0.00")])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("验收条目")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showDeviceItemFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowDeviceItem()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showDeviceItemFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showDeviceItemFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showDeviceItemFlag
        ? [
            _vm.purchReceipt.itemList != null &&
            _vm.purchReceipt.itemList.length > 0
              ? _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "dataTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.purchReceipt.itemList,
                          border: "",
                          maxHeight: "400",
                          "tooltip-effect": "dark",
                          "summary-method": _vm.getDevcItemSum,
                          "show-summary": ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "innerCode",
                            label: "资产编号",
                            width: "160",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  !rows.row.invalid
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "table-cell-link",
                                          on: {
                                            click: function($event) {
                                              _vm.viewAssetInfo(rows.row)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(rows.row.innerCode))]
                                      )
                                    : _c("span", [
                                        _vm._v(_vm._s(rows.row.innerCode))
                                      ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "goodsTitle",
                            label: "资产名称",
                            width: "200",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "assetNature",
                            label: "资产属性",
                            width: "120",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.assetNatureMap[rows.row.assetNature]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "catName",
                            label: "分类",
                            width: "150",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "brandName",
                            label: "品牌",
                            width: "150",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "quantity",
                            width: "100",
                            label: "数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "theUnit",
                            "min-width": "50",
                            label: "单位"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPrice",
                            align: "right",
                            width: "120",
                            label: "未税单价(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxPrice != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.ntxPrice.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate",
                            align: "right",
                            width: "120",
                            label: "税率(%)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxRate != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.taxRate.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wtxPrice",
                            align: "right",
                            width: "120",
                            label: "含税单价(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.wtxPrice != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.wtxPrice.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "initWtxPrice",
                            align: "right",
                            width: "120",
                            label: "含税原单价(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.initWtxPrice != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            rows.row.initWtxPrice.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "ntxAmount",
                            width: "120",
                            label: "未税小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.ntxAmount.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "taxAmount",
                            width: "120",
                            label: "税额小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.taxAmount.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "wtxAmount",
                            width: "100",
                            label: "含税小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.wtxAmount != null
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v(
                                          _vm._s(rows.row.wtxAmount.toFixed(2))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _vm.purchFeeNames.contains("LogisFee")
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "logisFee",
                                width: "100",
                                label: "物流小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.logisFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.logisFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchFeeNames.contains("AsmblFee")
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "asmblFee",
                                width: "100",
                                label: "组装小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.asmblFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.asmblFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchFeeNames.contains("SetupFee")
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "setupFee",
                                width: "100",
                                label: "安装小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.setupFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.setupFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchFeeNames.contains("TearFee")
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "tearFee",
                                width: "100",
                                label: "拆除小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.tearFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.tearFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchFeeNames.contains("toDoorFee")
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "toDoorFee",
                                width: "100",
                                label: "上门小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.toDoorFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.toDoorFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchFeeNames.contains("RepairFee")
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "repairFee",
                                width: "100",
                                label: "维修小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.repairFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.repairFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchFeeNames.contains("OthersFee")
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "otherFee",
                                width: "140",
                                label: "其他杂费小计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.otherFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.otherFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _c("span", [_vm._v("0.00")])
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.purchFeeNames || []).length > 0
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                prop: "xtraFee",
                                width: "140",
                                label: "分摊费用总计(元)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.xtraFee != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.xtraFee.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _c("span", [_vm._v("0.00")])
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "invoiceState",
                            width: "100",
                            label: "开票状态"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.invoiceStateMap[
                                          rows.row.invoiceState
                                        ]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _vm.showBizUnitWarehouse
                          ? _c("el-table-column", {
                              attrs: {
                                align: "left",
                                prop: "warehouseName",
                                width: "150",
                                label: "入库仓库"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(rows.row.warehouseName))
                                      ])
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showBizUnitWarehouse
                          ? _c("el-table-column", {
                              attrs: {
                                align: "left",
                                prop: "assetType",
                                width: "150",
                                label: "管理方式"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.assetTypeMap[rows.row.assetType]
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "customized",
                            width: "100",
                            label: "定制商品"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.customized ? "是" : "否")
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.purchReceipt.pullBackNo != null &&
      _vm.purchReceipt.pullBackNo != "" &&
      _vm.purchReceipt.pulledBackOuterAuditFlag
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("冲销审批记录")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr",
                class: _vm.showOaAuditBackFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowOaAuditBackInfo()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showOaAuditBackFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showOaAuditBackFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showOaAuditBackFlag &&
      _vm.purchReceipt.pullBackNo != null &&
      _vm.purchReceipt.pullBackNo != "" &&
      _vm.purchReceipt.pulledBackOuterAuditFlag
        ? [
            _c("swb-oa-audit-rec-list", {
              ref: "swb_oa_audit_rec_list",
              attrs: {
                bizTypeCode: "retailer.assets.purch.receipt",
                bizVoucherNo: _vm.purchReceipt.innerNo,
                auditSeqNo: _vm.purchReceipt.pulledBackAuditSeqNo
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("记账凭证号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购部门/门店")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "form-label" }, [_c("label")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "form-label" }, [_c("label")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单据创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收生凭时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已冲销")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销审批状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销凭证号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销生凭时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已作废")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("作废原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否抵扣税")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("约定税率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("税率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("锁帐未生凭")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("对接推送失败原因")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19647006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19647006","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/PurchReceiptDetail.vue
// module id = 2995
// module chunks = 0